



































































import {Component, Vue, Config, BasePage, Watch} from '@/common';
import contrEdit from './components/contrEdit.vue';
import {TwTable} from '@/components';
import {settings} from 'cluster';

@Component({
	components: {
		contrEdit,
	},
})
export default class offer extends BasePage {
	get table(): TwTable {
		return this.$refs['table'] as TwTable;
	}

	rowGuid = '';
	showEdit = false;
	columns = [];
	CUSTOM_NAME = [];
	loading = false;
	fileKey = '';

	searchMode = {
		CUSTOM_NAME: '',
		CREATE_DATE_FROM: null,
		CREATE_DATE_TO: null,
	};

	ok() {
		this.table.reload();
		this.fileKey = '';
	}

	add() {
		this.rowGuid = '';
		this.showEdit = true;
	}

	refresh() {
		this.table.load({...this.searchMode});
		this.fileKey = '';
	}

	dbClick(row) {
		this.showEdit = true;
		this.rowGuid = row.GUID;
	}

	rowClick(row) {
		this.fileKey = row.CONTR_NO;
	}

	deleteRows() {
		this.$confirm('此操作将永久删除该数据以及明细, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		})
			.then(() => {
				this.$http
					.post('Biz/Contr/Delete', {
						GUID: this.table.getSelections().map((item) => item.GUID),
					})
					.then((res) => {
						if (res.data.status === 0) {
							this.$message.success('删除成功');
							this.fileKey = '';
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	download() {
		if (
			!(
				this.table.getSelections().length > 0 &&
				this.table.getSelections().map((item) => item.GUID).length == 1
			)
		) {
			this.$message.warning('导出只能勾选一行数据');
			return;
		}

		this.loading = true;
		this.$http
			.post(
				'Biz/Contr/GetExeclFile',
				{typeValue: this.table.getSelections().map((item) => item.GUID)},
				{responseType: 'blob'}
			)
			.then((res) => {
				this.loading = false;
				const filename = decodeURIComponent(res.headers['filename']);
				if (window.navigator.msSaveOrOpenBlob) {
					navigator.msSaveBlob(res.data, filename);
				} else {
					let url = window.URL.createObjectURL(res.data);
					let link = document.createElement('a');
					link.style.display = 'none';
					link.href = url;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
					URL.revokeObjectURL(link.href);
				}
			})
			.catch((err) => {
				this.loading = false;
			});
	}

	mounted() {
		this.buildColumn('002003', this.columns);
		this.loadCustom();
	}

	loadCustom() {
		this.$http.get('Biz/Contr/GetCustom').then((res) => {
			if (res.data.status === 0) {
				this.CUSTOM_NAME.splice(0);
				this.CUSTOM_NAME.push(...res.data.CUSTOMINFO);
			}
		});
	}
}
